import React from "react";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";

import { Input } from "../Input";
import { Select } from "../Select";

dayjs.extend(customParseFormat);

export const PERIOD_OPTIONS = [
  { value: "7", label: "Últimos 7 dias" },
  { value: "15", label: "Últimos 15 dias" },
  { value: "30", label: "Últimos 30 dias" },
  { value: "90", label: "Últimos 90 dias" },
  { value: "custom", label: "Personalizado" },
];

const API_FORMAT = "YYYY-MM-DD";
const VIEW_FORMAT = "DD/MM/YYYY";

/** Deduz a opcao a partir do intervalo. Fim diferente de hoje => Personalizado. */
export function periodFromRange(dateFrom, dateTo) {
  const from = dayjs(dateFrom);
  const to = dayjs(dateTo);

  if (!from.isValid() || !to.isValid()) return "custom";
  if (!to.isSame(dayjs(), "day")) return "custom";

  const days = to.diff(from, "day");
  const match = PERIOD_OPTIONS.find((option) => option.value === String(days));

  return match ? match.value : "custom";
}

export function rangeFromPeriod(period) {
  const to = dayjs();
  const from = to.subtract(Number(period), "day");

  return { dateFrom: from.format(API_FORMAT), dateTo: to.format(API_FORMAT) };
}

/**
 * Um campo so no lugar de "7 dias / 30 dias / 90 dias / Personalizado" mais dois
 * calendarios. Os calendarios so aparecem quando o periodo e Personalizado.
 *
 * Modo simples: passe onChange, que recebe { dateFrom, dateTo } em YYYY-MM-DD.
 * Modo controlado: passe period + onPeriodChange + onDateChange, para quem ja
 * guarda o periodo escolhido na propria store e faz a conversao.
 */
export function PeriodFilter({
  dateFrom,
  dateTo,
  onChange,
  period: periodProp,
  onPeriodChange,
  onDateChange,
  options = PERIOD_OPTIONS,
  label = "Período",
  style,
  disabled = false,
  withPeriod = false,
}) {
  const controlled = typeof onPeriodChange === "function";
  const period = controlled ? periodProp : periodFromRange(dateFrom, dateTo);
  const mostraDatas = !withPeriod || period === "custom";

  const handlePeriod = (value) => {
    if (controlled) {
      onPeriodChange(value);
      return;
    }

    if (value === "custom") {
      onChange({ dateFrom, dateTo });
      return;
    }

    onChange(rangeFromPeriod(value));
  };

  const handleDate = (field, value) => {
    if (controlled) {
      onDateChange(field, value);
      return;
    }

    // o campo mostra DD/MM/AAAA; a API espera AAAA-MM-DD
    const parsed = dayjs(value, VIEW_FORMAT, true);
    const apiValue = parsed.isValid() ? parsed.format(API_FORMAT) : "";

    onChange(
      field === "from" ? { dateFrom: apiValue, dateTo } : { dateFrom, dateTo: apiValue }
    );
  };

  return (
    <>
      {withPeriod && (
      <Select.Root
        label={label}
        disabled={disabled}
        value={period}
        style={{ minWidth: "170px", maxWidth: "190px", ...style }}
        onChange={handlePeriod}
      >
        {options.map((option) => (
          <Select.Option key={option.value} value={option.value}>
            {option.label}
          </Select.Option>
        ))}
      </Select.Root>
      )}

      {mostraDatas && (
        <>
          <Input.Root
            pickDate
            label="Início"
            disabled={disabled}
            value={dayjs(dateFrom).isValid() ? dayjs(dateFrom).format(VIEW_FORMAT) : ""}
            onChange={(value) => handleDate("from", value)}
          />
          <Input.Root
            pickDate
            label="Fim"
            disabled={disabled}
            value={dayjs(dateTo).isValid() ? dayjs(dateTo).format(VIEW_FORMAT) : ""}
            onChange={(value) => handleDate("to", value)}
          />
        </>
      )}
    </>
  );
}
